import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import getters from './getter'
import abPop from './modules/abPop'
import common from './modules/common'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters,
  modules: {
    user,
    abPop,
    common
  }
})
